import { Heading, Stack, Badge } from '@backyard-ui/core';

import { Image } from '@/presenters/components/common/Image';
import { useProductStore } from '@/presenters/store/catalog/product';

function MainProduct() {
  const { name, _id, visualMedias } = useProductStore((store) => store.product);

  const mediaItem = visualMedias.medias[0];

  return (
    <Stack align="center" className="p-4" spacing="4">
      {mediaItem.main && (
        <Image
          src={mediaItem.main}
          alt={mediaItem.alt}
          width={96}
          height={96}
          className="h-24 w-24"
        />
      )}
      <Stack direction="column" spacing="4" align="flex-start">
        <Heading size="sm" asChild>
          <div role="heading" aria-level={1}>
            {name}
          </div>
        </Heading>
        <Badge
          appearance="neutral"
          variant="subtle"
          UNSAFE_className="select-auto"
        >
          Cód: {_id}
        </Badge>
      </Stack>
    </Stack>
  );
}

export default MainProduct;
